import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap'

import { alertaErro, downloadBranco } from '../../../utils/alternanciaIcones'

/**
 * @typedef {Object} MensagemErroProps
 * @property {(confirmacao: boolean) => void} handleMensagemErro - Função obrigatória para tratar o fechamento/ação da mensagem
 * @property {string} [mensagemTitulo] - Título exibido na mensagem
 * @property {string} [mensagemParagrafo1] - Primeiro parágrafo do corpo
 * @property {string} [mensagemParagrafo2] - Segundo parágrafo do corpo
 * @property {string} [mensagemParagrafo3] - Terceiro parágrafo do corpo
 * @property {string} [mensagemBotao] - Texto do botão principal
 * @property {string} [mensagemBotao2] - Texto do botão secundário (se houver)
 * @property {boolean} [centralizarBotao] - Define se o botão deve ficar centralizado
 * @property {boolean} [botao1Disabled] - Desabilita o botão principal
 * @property {() => void} [downloadNoBotao2] - Função chamada no clique do botão secundário
 */

/**
 * @param {MensagemErroProps} props
 */
export default function MensagemErro(props) {
  const [mensagemTitulo, setMensagemTitulo] = useState('')
  const [mensagemParagrafo1, setMensagemParagrafo1] = useState('')
  const [mensagemParagrafo2, setMensagemParagrafo2] = useState('')
  const [mensagemParagrafo3, setMensagemParagrafo3] = useState('')
  const [mensagemBotao, setMensagemBotao] = useState('')
  const [mensagemBotao2, setMensagemBotao2] = useState('')

  const modal = useRef()

  const handleClickFora = (e) => {
    if (!modal.current.contains(e.target)) {
      if (props.downloadNoBotao2) props.downloadNoBotao2() // apenas se for download de arquivo de erros

      handleCancelar(false)
    }
  }

  function handleCancelar(confirmacao) {
    if (confirmacao === true) {
      props.handleMensagemErro(true)
    } else {
      props.handleMensagemErro(false)
    }
  }

  useEffect(() => {
    setMensagemTitulo(props.mensagemTitulo)
    setMensagemParagrafo1(props.mensagemParagrafo1)
    setMensagemParagrafo2(props.mensagemParagrafo2)
    setMensagemParagrafo3(props.mensagemParagrafo3)
    setMensagemBotao(props.mensagemBotao)
    setMensagemBotao2(props.mensagemBotao2)
    document.addEventListener('mousedown', handleClickFora)
    return () => document.removeEventListener('mousedown', handleClickFora)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="mensagem-overlay">
      <div className="mensagem-container">
        <div ref={modal} className="mensagem-corpo fundo-cor-6">
          <div className="mensagem-container-icone">
            <img className="mensagem-icone" src={alertaErro()} alt="sucesso" />
          </div>
          <div className="mensagem-container-titulo">
            <div className="fonte-cor-1 label-titulo-mensagem">
              {mensagemTitulo}
            </div>
          </div>
          <div>
            <div className="fonte-cor-1 label-corpo-mensagem">
              {mensagemParagrafo1}
            </div>
          </div>
          <div>
            <div className="fonte-cor-1 label-corpo-mensagem">
              {mensagemParagrafo2}
            </div>
          </div>
          <div>
            <div className="fonte-cor-1 label-corpo-mensagem">
              {mensagemParagrafo3}
            </div>
          </div>

          <div
            className="mensagem-container-botao"
            style={{
              display: 'flex',
              justifyContent: props.centralizarBotao ? 'center' : 'end'
            }}
          >
            <Button
              disabled={props.botao1Disabled}
              className="mensagem-botao-cancelar"
              variant="success"
              size="sm"
              onClick={() => handleCancelar(true)}
            >
              <div
                className={props.botao1Disabled ? 'fonte-cor-1' : 'fonte-cor-2'}
              >
                {mensagemBotao}
              </div>
            </Button>

            {mensagemBotao2 && (
              <Button
                className="botao-confirmar"
                type="submit"
                variant="success"
                size="sm"
                onClick={() => props.downloadNoBotao2()}
              >
                <div>
                  {mensagemBotao2}
                  <img className="ml-2" src={downloadBranco()} alt="sucesso" />
                </div>
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export function RenderMensagemErro(props) {
  return (
    <div className="componente-modal-overlay">
      <div className="componente-modal">
        <MensagemErro {...props} />
      </div>
    </div>
  )
}
